module.exports = __webpack_public_path__ + "static/media/BladeRX_S7_adapter.c32cd024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeRX_S7_adapter.jpg
// module id = 827
// module chunks = 0